import React, {useState, useRef} from 'react'
import PropTypes from 'prop-types'
import {Box, useBreakpointValue, useMultiStyleConfig} from '@chakra-ui/react'
import YoutubeIframe from '../../youtube-video'
import {getDamImageUrl} from '../../../utils/contentstack-utils'
import {PlayIcon} from '../../icons'

export const EditorialVideo = ({data}) => {
    const [isPlaying, setIsPlaying] = useState(false)
    const videoRef = useRef(null)

    const styles = useMultiStyleConfig('Video')

    const handlePlayPause = () => {
        if (videoRef.current) {
            if (videoRef.current.paused) {
                videoRef.current.play()
                setIsPlaying(true)
            } else {
                videoRef.current.pause()
                setIsPlaying(false)
            }
        }
    }

    const handleVideoEnd = () => {
        setIsPlaying(false)
    }

    const videoSrc = useBreakpointValue({
        base: data?.akamai_videos?.mobile || data?.akamai_videos?.desktop,
        sm: data?.akamai_videos?.desktop,
    })
    const videoThumbnail = useBreakpointValue({
        base: getDamImageUrl(data?.mobile_fallback_thumbnaill),
        sm: getDamImageUrl(data?.desktop_fallback_thumbnail),
    })

    if (data?.type_of_video === 'Akamai reference') {
        return (
            <Box {...styles.videoContainer}>
                <Box
                    as="video"
                    ref={videoRef}
                    onEnded={handleVideoEnd}
                    onPlay={() => setIsPlaying(true)}
                    onPause={() => setIsPlaying(false)}
                    muted
                    aria-hidden="true"
                    {...styles.video}
                >
                    <source src={videoSrc} type="video/mp4" />
                    Your browser does not support the video tag.
                </Box>

                <Box as="button" onClick={handlePlayPause} {...styles.playIconContainer}>
                    {!isPlaying && <PlayIcon {...styles.playIcon} data-testid="play-icon" />}
                </Box>
            </Box>
        )
    }

    if (data?.type_of_video === 'Youtube link') {
        return (
            <Box {...styles.videoContainerYoutube} data-testid="youtube-video">
                <YoutubeIframe
                    title={data?.title}
                    videoSrc={data?.youtube_link}
                    thumbnail={videoThumbnail}
                />
            </Box>
        )
    }
}

EditorialVideo.propTypes = {
    data: PropTypes.object,
}
